import React, { useState, useEffect } from 'react';
import './styles/components.css';

const ReusableTable = ({ data, columns, actionRender }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  // Reset page to 1 when data changes (e.g., after a search)
  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page on size change
  };

  return (
    <div className="table-container">
      <table className="reusable-table">
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key}>{col.label}</th>
            ))}
            {actionRender && <th>Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan={columns.length + (actionRender ? 1 : 0)} style={{ textAlign: 'center', color: '#888' }}>
                No hay datos para mostrar
              </td>
            </tr>
          ) : (
            currentItems.map((row, idx) => {
              const rowKey = row.id_parametro !== undefined ? row.id_parametro : (row.idUsuario || idx);
              return (
                <tr key={rowKey}>
                  {columns.map(col => (
                    <td key={`${col.key}-${rowKey}`}>
                      {col.formatter
                        ? col.formatter(row[col.key], row)
                        : (col.key === 'estado' && (row[col.key] === true || row[col.key] === 1))
                          ? 'Activo'
                          : (col.key === 'estado' && (row[col.key] === false || row[col.key] === 0))
                            ? 'Inactivo'
                            : row[col.key]
                      }
                    </td>
                  ))}
                  {actionRender && (
                    <td>
                      {actionRender(row)}
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <div className="pagination-controls">
        <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
          <option value={15}>15 por página</option>
          <option value={30}>30 por página</option>
          <option value={100}>100 por página</option>
        </select>
        <div className="page-navigation">
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            Anterior
          </button>
          <span>Página {currentPage} de {totalPages}</span>
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusableTable;